module.exports = __webpack_public_path__ + "static/img/Logo.367de5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo.png
// module id = 13
// module chunks = 0